<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">

    <div class="card shadow-0 border-0" style="background-color:inherit">
      <div class="card-body skin light-bg text-center card-img-top" >
        <div class="card-img-actions d-inline-block mb-3">
          <img class="img-fluid rounded-circle" src="/images/user_200x200.jpg" alt="" width="170" height="170">
          <div class="card-img-actions-overlay card-img rounded-circle">
            <a href="#" class="btn btn-outline-dark border-2 btn-icon rounded-pill">
              <i class="icon-plus3"></i>
            </a>
            <a href="user_pages_profile.html" class="btn btn-outline-white border-2 btn-icon rounded-pill ml-2">
              <i class="icon-link"></i>
            </a>
          </div>
        </div>

        <h6 class="font-weight-semibold mb-0 font-weight-bolder">{{firstname}} {{lastname}}</h6>
        <span v-if="role != null && role != ''" class="d-block opacity-75">{{role}}<br /></span>
        <span v-if="roledescription != null && roledescription != ''" class="d-block opacity-75">{{roledescription}}<br /></span>

        <ul class="list-inline list-inline-condensed mt-3 mb-0">

          <li v-if="phone != null && phone != ''" class="list-inline-item">
            <a v-bind:href="'tel:' + phone" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-phone2"></i>
            </a>
          </li>
          <li v-if="skype != null && skype != ''" class="list-inline-item">
            <a v-bind:href="'skype:' + skype + '?call'" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-skype"></i>
            </a>
          </li>
          <li v-if="linkedin != null && linkedin != ''" class="list-inline-item">
            <a v-bind:href="'https://ie.linkedin.com/in/' + linkedin" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-linkedin2"></i>
            </a>
          </li>
          <li v-if="facebook != null && facebook != ''" class="list-inline-item">
            <a v-bind:href="facebook" class="btn btn-outline-dark btn-icon border-2 rounded-pill">
              <i class="icon-facebook"></i>
            </a>
          </li>
        </ul>
      </div>

      <div class="card-body border-top-0">
        <div v-if="phone != null && phone != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('phone')}}:</div>
          <div class="col-6">{{phone}}</div>
        </div>
        <div v-if="email != null && email != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('email')}}:</div>
          <div class="col-6"><a href="#">{{email}}</a></div>
        </div>
        <div v-if="address != null && address != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('address')}}:</div>
          <div class="col-6">{{address}}</div>
        </div>
        <div v-if="skype != null && skype != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('skype')}}:</div>
          <div class="col-6">{{skype}}</div>
        </div>
        <div v-if="facebook != null && facebook != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('facebook')}}:</div>
          <div class="col-6">{{facebook}}</div>
        </div>
        <div v-if="linkedin != null && linkedin != ''" class="row mb-3">
          <div class="col-3"></div>
          <div class="font-weight-semibold col-3">{{$t('linkedin')}}:</div>
          <div class="col-6">{{linkedin}}</div>
        </div>
        <div v-if="notes != null && notes != ''" class="row mb-3">
          <div class="font-weight-semibold col-12">{{$t('notes')}}:</div>
          <div class="col-12 py-3" v-html="notes" style=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  export default {
    name: "view-contact",
    components: {

    },
    props: {
      contactId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        address: "",
        role: "",
        notes: "",
        roledescription: "",
        skype: "",
        facebook: "",
        linkedin: ""
      };
    },
    methods: {
      async getContact(contactId) {
        try {         
          this.$http.get(`/api/Contacts/v1/${contactId}`).then(async response => {
            var contact = response.data;
            this.firstname = contact.FirstName;
            this.lastname = contact.LastName;
            this.email = contact.Email;
            this.phone = contact.Phone;
            this.address = contact.Address;
            this.role = contact.Role;
            this.notes = contact.Notes;
            this.roledescription = contact.Roledescription;
            this.skype = contact.Skype;
            this.facebook = contact.Facebook;
            this.linkedin = contact.Linkedin;

            if (this.notes != null && typeof (this.notes) != 'undefined') {
              this.notes = this.notes.replace(/(?:\r\n|\r|\n)/g, '<br>');
            }

          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      contactId: function (newVal, oldVal) {        
        if (newVal > 0) {
          this.getContact(newVal);
        }
      }
    },
    mounted() {
      if (this.contactId > 0) {
        this.getContact(this.contactId);
      }
    }
  };
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/contact/view-contact.vue